module.exports = __webpack_public_path__ + "static/media/Portrait-10240.f180701d.jpg";